import { useEffect, useRef, useState } from "react";
import { Alert, Button, Card, Col, Divider, Row, Grid } from "antd";

import { PlusOutlined, SearchOutlined } from "@ant-design/icons";

import { openNotification, OrganizationForm, OrganizationList } from "@seims/shared";


export const Organisations = ({
  formRef,
  onHideButtons,
  onSelectedOrganization,
  selectedOrganization,
  selectedRowKeys,
  setSelectedRowKeys,
  setSelectedGlobalOrganization,
  onUpdateSelected,
  onRemoveSelected,
  api,
  title = "Contributing Organisation(s)",
  titleStyle = "card",
  isEdit,
  mode = "add", // add, edit, view
  organizationBelongsTo = "project",
}) => {
  const isEventsPwa = organizationBelongsTo === "event";
  const [showCreate, setShowCreate] = useState(false);
  const [showPartnerList, setShowPartnerList] = useState(true);
  const [hasUpdated, setHasUpdated] = useState(false);
  const [preselectedOrgs, setPreSelectedOrgs] = useState({});
  const [orgnaisationToEdit, setOrgnaisationToEdit] = useState({});
  const [activeAction, setActiveAction] = useState("search");

  const scrollRef = useRef(null);

  const screens = Grid.useBreakpoint();
  const isMobile = !screens.md;

  let msg = "";

  const isAddEditMode = ["add", "edit"].includes(mode);
  console.log("activeAction:", activeAction);
  useEffect(() => {
    // THis was added because the Organization page displayed halfway through
    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }
  }, []);

  useEffect(() => {
    if (!isEdit) return;

    if (Array.isArray(selectedOrganization)) {
      const keys = selectedOrganization.map(org =>
        org.id.toString()
      );

      setSelectedRowKeys(keys);
      setSelectedGlobalOrganization(selectedOrganization);
    }
  }, [isEdit, selectedOrganization]);

  const handleRowKeySelection = (rows) => {
    setSelectedRowKeys(rows);
  };

  const handleSaveOrganization = (organization) => {
    // addOrganization(partner, address)
    setPreSelectedOrgs(organization);
    setHasUpdated(true);
  };

  const handleAddOrganization = () => {
    setActiveAction("add");
    setShowCreate(true);
    setShowPartnerList(false);
    onHideButtons(true);
  };

  const onShowPartnerList = () => {
    setActiveAction("search");
    setShowPartnerList(true);
    setShowCreate(false);
    onHideButtons(false);
  };

  const handleEditOrganization = (organization) => {
    setOrgnaisationToEdit(organization);
    setShowCreate(true);
    onHideButtons(true);
  };

  return (
    <div
      className="project-card"
      title={
        <span
          style={{ color: "black", fontWeight: "bold", fontSize: "20px" }}
        >
          <b>{title}</b>
        </span>
      }
      bordered={true}
      headStyle={{ border: 0, textAlign: "left" }}
    >
      {
        titleStyle === "step" ? (
          <div className="step-title">{title}</div>
        ) : (
          <span className="event-card-borderless-header-text">
            <b style={{ fontSize: '16px' }}>{title}</b>
          </span>
        )
      }
      <p style={{ textAlign: "left" }}>
        Add a Contributing Organisation by either searching for an existing organisation or creating a new organisation.
      </p>
      <div style={{ textAlign: "left" }}>
        <Alert
          description={
            <span>
              <b>Please Note:</b> {isEventsPwa ?
              (<>Your event must include only one <b>Host Organisation</b> and at least one <b>Funding</b> organisation.</>)
              : "Before proceeding to the next step, you must specifiy which Contributing Organisation(s) will provide Funding and Host Contributions"}
            </span>
          }
          type="info"
          showIcon
          style={{ marginBottom: 12 }}
        />
      </div>
      <div ref={scrollRef} className="mobile-partner-actions">
        {isMobile ? (
          /*  MOBILE LAYOUT */
          <div className="mobile-partner-actions">
            <Button
              disabled={!isAddEditMode}
              type={activeAction === "search" ? "primary" : "default"}
              block
              icon={<SearchOutlined />}
              onClick={() => onShowPartnerList(true)}
            >
              Search for an existing Organisation
            </Button>

            <div className="mobile-or">OR</div>

            <Button
              disabled={!isAddEditMode}
              type={activeAction === "add" ? "primary" : "default"}
              block
              icon={<PlusOutlined />}
              onClick={() => handleAddOrganization(true)}
            >
              Add a new Organisation
            </Button>
          </div>
        ) : (
          /*  DESKTOP LAYOUT (unchanged) */
          <Row
            gutter={16}
            align="middle"
            style={{ marginTop: 16, marginBottom: 16 }}
          >
            <Col>
              <Button
                disabled={!isAddEditMode}
                type={activeAction === "search" ? "primary" : "default"}
                icon={<SearchOutlined />}
                onClick={() => onShowPartnerList(true)}
              >
                Search for an Organisation
              </Button>
            </Col>

            <Col style={{ paddingTop: 2, paddingBottom: 2 }}>
              <span style={{ color: "#777", fontWeight: 500 }}>Or</span>
            </Col>

            <Col>
              <Button
                disabled={!isAddEditMode}
                type={activeAction === "add" ? "primary" : "default"}
                icon={<PlusOutlined />}
                onClick={() => handleAddOrganization(true)}
              >
                Add a new Organisation
              </Button>
            </Col>
          </Row>
        )}

        {showCreate ? (
          <OrganizationForm
            api={api}
            formRef={formRef}
            onShowCreate={handleAddOrganization}
            onSaveOrganization={handleSaveOrganization}
            onCancelForm={onShowPartnerList}
            formData={orgnaisationToEdit}
            resetFormData={setOrgnaisationToEdit}
            loadDetails={!!orgnaisationToEdit?.id}
          />
        ) : (
          <>

            {showPartnerList && (
              <OrganizationList
                isEdit={isEdit}
                mode={mode}
                api={api}
                formRef={formRef}
                hasUpdated={hasUpdated}
                preselectedOrgs={preselectedOrgs}
                onHideButtons={(value) => handleAddOrganization((value))}
                onSelectedOrganization={onSelectedOrganization}
                onUpdateSelected={handleEditOrganization}
                onRemoveSelected={onRemoveSelected}
                selectedGlobalOrganization={selectedOrganization}
                selectedRowKeys={selectedRowKeys}
                setSelectedRowKeys={handleRowKeySelection}
                setSelectedGlobalOrganization={setSelectedGlobalOrganization}
                organizationBelongsTo={organizationBelongsTo}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
}
